import { makeStyles, createStyles, Theme, FormControlLabel } from "@material-ui/core";
import React from "react";

import { SwitchControl, SwitchControlProps } from "./SwitchControl";

export type SwitchProps = {
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
  label?: string;
} & SwitchControlProps;

export const Switch = ({ title, checked, label, ...props }: SwitchProps) => {
  const classes = useStyles();

  return (
    <FormControlLabel
      className={classes.label}
      control={<SwitchControl checked={checked} {...props} />}
      label={label}
    />
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    label: {
      marginLeft: -9,
    },
  }),
);
